var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import * as ServiceAffaire from '../../services/affaire';
import * as ServiceClient from '../../services/client';
import { EditionEquipe } from './EditionEquipe';
import { Link } from '../../utils/Link';
import { Stack } from '@mui/material';
import { CollaborateurIcon, CloseIcon, StarIcon } from '../../utils/Icons';
import { IconButton } from '../../utils/IconButton';
import { Table } from '../../utils/Table';
import { Switch } from '../../utils/Switch';
import { ConfirmDialog } from '../../utils/ConfirmDialog';
import { formatDateTime } from '../../services/utils/utils';
import { getOriginalUser } from '../../services/utilisateur';
export var Equipe = function (props) {
    var ObjetId = props.ObjetId, ObjetType = props.ObjetType, _a = props.CanEditEquipe, CanEditEquipe = _a === void 0 ? false : _a;
    var originalUser = getOriginalUser();
    var _b = useState([]), equipes = _b[0], setEquipes = _b[1];
    var _c = useState(false), displayAll = _c[0], setDisplayAll = _c[1];
    var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var newEquipes;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newEquipes = [];
                    if (!(ObjetType === 'Client')) return [3 /*break*/, 2];
                    return [4 /*yield*/, ServiceClient.getClientEquipeListe(ObjetId)];
                case 1:
                    newEquipes = _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    if (!(ObjetType === 'Affaire')) return [3 /*break*/, 4];
                    return [4 /*yield*/, ServiceAffaire.getAffaireEquipeListe(ObjetId)];
                case 3:
                    newEquipes = _a.sent();
                    _a.label = 4;
                case 4:
                    setEquipes(newEquipes);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleClickDelete = function (equipe) { return __awaiter(void 0, void 0, void 0, function () {
        var confirmation;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ConfirmDialog({
                        title: 'Suppression',
                        content: 'Êtes-vous sûr de vouloir supprimer ce membre ?',
                        color: 'error',
                    })];
                case 1:
                    confirmation = _a.sent();
                    if (!confirmation.isOk) return [3 /*break*/, 6];
                    if (!(ObjetType == 'Client')) return [3 /*break*/, 3];
                    return [4 /*yield*/, ServiceClient.deleteClientEquipe(equipe.IdClientCollaborateur)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    if (!(ObjetType == 'Affaire')) return [3 /*break*/, 5];
                    return [4 /*yield*/, ServiceAffaire.deleteAffaireEquipe(equipe.IdAffaireCollaborateur)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    getData();
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleChangeProprietaire = function (CollaborateurId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(ObjetType == 'Affaire')) return [3 /*break*/, 2];
                    return [4 /*yield*/, ServiceAffaire.changeProprietaire(ObjetId, CollaborateurId)];
                case 1:
                    _a.sent();
                    getData();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var equipeActives = equipes
        ? equipes
            .filter(function (e) { return e.DateSuppression === null; })
            .sort(function (a, b) {
            if (new Date(b.createdAt) < new Date(a.createdAt)) {
                return -1;
            }
            return 1;
        })
        : [];
    var equipeInactives = equipes
        ? equipes
            .filter(function (e) { return e.DateSuppression !== null; })
            .sort(function (a, b) {
            if (new Date(b.DateSuppression) < new Date(a.DateSuppression)) {
                return -1;
            }
            return 1;
        })
        : [];
    return (_jsx(_Fragment, { children: _jsx(Table, { canEdit: ObjetId && CanEditEquipe, renderModalEdition: function (handleClose) { return (_jsx(EditionEquipe, { ObjetId: ObjetId, ObjetType: ObjetType, handleClose: function () {
                    getData();
                    handleClose();
                } })); }, refresh: getData, renderFooter: equipeInactives.length > 0
                ? function () { return (_jsx(Stack, __assign({ direction: "row", justifyContent: "flex-end" }, { children: _jsx(Switch, { label: "Afficher l'historique", checked: displayAll, onChange: function (e) { return setDisplayAll(e.target.checked); } }) }))); }
                : null, headers: [
                {
                    component: function (value) { return (_jsxs(Stack, __assign({ direction: "row", spacing: 2, alignItems: "center" }, { children: [originalUser.Licence.UseVision &&
                                !value.DateSuppression &&
                                value.IsProprietaire !== undefined && (_jsx(IconButton, __assign({ tooltip: value.IsProprietaire
                                    ? 'Est propriétaire'
                                    : 'Cliquer pour changer de propriétaire', color: value.IsProprietaire ? 'warning' : 'neutre', onClick: function () {
                                    return handleChangeProprietaire(value.CollaborateurId);
                                } }, { children: _jsx(StarIcon, {}) }))), value.collaborateur && (_jsx(Link, { bold: true, title: value.collaborateur.getLibelle, color: "collaborateur", to: '/collaborateur/fiche/' +
                                    value.collaborateur.IdCollaborateur, icon: _jsx(CollaborateurIcon, {}) }))] }))); },
                },
                {
                    align: 'right',
                    component: function (value) { return (_jsxs(Stack, __assign({ justifyContent: "flex-end" }, { children: [_jsx(Stack, __assign({ justifyContent: "flex-end" }, { children: "Ajout\u00E9 le ".concat(formatDateTime(value.createdAt, false)).concat(value.utilisateur_ajout &&
                                    value.utilisateur_ajout.getLibelle
                                    ? " par ".concat(value.utilisateur_ajout.getLibelle)
                                    : '') })), value.DateSuppression && (_jsx(Stack, __assign({ justifyContent: "flex-end" }, { children: "Supprim\u00E9 le ".concat(formatDateTime(value.DateSuppression, false)).concat(value.utilisateur_supp &&
                                    value.utilisateur_supp.getLibelle
                                    ? " par ".concat(value.utilisateur_supp.getLibelle)
                                    : '') })))] }))); },
                },
                {
                    align: 'right',
                    component: function (value) {
                        return equipeActives.length > 1 &&
                            !value.IsProprietaire &&
                            !value.DateSuppression &&
                            CanEditEquipe ? (_jsx(IconButton, __assign({ tooltip: "Supprimer", color: "error", size: "small", onClick: function () { return handleClickDelete(value); } }, { children: _jsx(CloseIcon, {}) }))) : (_jsx(_Fragment, {}));
                    },
                },
            ], datas: __spreadArray(__spreadArray([], (equipeActives ? equipeActives : []), true), (displayAll && equipeInactives ? equipeInactives : []), true) }) }));
};
//# sourceMappingURL=Equipe.js.map